import { Component, OnInit, Input, Output, OnChanges, ViewChild, EventEmitter } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';
import { Moment } from 'moment';
import { FiaService } from 'src/app/services/fia.service';
import { MediaService } from 'src/app/services/media.service';
import { SettingsService } from 'src/app/services/settings.service';
import { SystemService } from 'src/app/services/system.service';
import { UserService } from 'src/app/services/user.service';
import { LookupFiaStatus } from 'src/app/shared/models/general/lookup-fia-status';
import { LookupMediaTypes } from 'src/app/shared/models/general/lookup-media-types';
import { MediaInfo } from 'src/app/shared/models/general/media-info';
import { SystemSetting } from 'src/app/shared/models/general/system-setting';
import { Fia } from 'src/app/shared/models/users/fia';
import { FiaApplication } from 'src/app/shared/models/users/fia-application';
import { FiaLeftToApplyFor } from 'src/app/shared/models/users/fia-left-to-apply-for';
import { UserFiaPinDocument } from 'src/app/shared/models/users/user-fia-pin-document';
import { UserProfile } from 'src/app/shared/models/users/user-profile';
import { Error } from 'src/app/shared/models/general/error';

@Component({
  selector: 'app-fia-application',
  templateUrl: './fia-application.component.html',
  styleUrls: ['./fia-application.component.scss'],
})
export class FiaApplicationComponent implements OnInit, OnChanges {
  @ViewChild('userFiaApplicationModal', { static: true })
  userFiaApplicationModal: any;
  @ViewChild('file') file;

  @Input() selectedUserProfile: UserProfile;
  @Input() showModal: boolean = false;
  @Input() fiaApplications: FiaApplication[];
  @Output() showModalChange = new EventEmitter<boolean>();
  @Output() onModelChange = new EventEmitter<UserProfile>();

  busy: boolean = false;
  settingBusy: boolean = false;
  showError: boolean;
  errorMsg: string = '';
  fiaStatus: LookupFiaStatus[] = [];
  mediaTypes: LookupMediaTypes[] = [];
  fiaLeftToApplyFor: FiaLeftToApplyFor = new FiaLeftToApplyFor();

  userProfile: UserProfile = new UserProfile();

  //FIA Application
  newFia: Fia = new Fia();
  currentYear = moment().year();
  today = moment();
  userNewDocuments: MediaInfo[] = [];
  supportingApplicationDocuments: MediaInfo[] = [];
  supportingApplicationDocumentsError: boolean = false;
  isPending: boolean = false;
  lastFiaApplication: FiaApplication = new FiaApplication();

  aitDocEnabledSetting: SystemSetting = new SystemSetting();
  isChecked: boolean = false;

  constructor(
    public settingsService: SettingsService,
    public usersService: UserService,
    public activeModal: NgbActiveModal,
    public fiaService: FiaService,
    public mediaService: MediaService,
    public systemService: SystemService
  ) {
    this.clearErrors();
  }

  ngOnInit(): void {
    this.fiaStatus = this.settingsService.fiaStatus;
    this.mediaTypes = this.settingsService.mediaTypes;
  }

  ngOnChanges() {
    this.showHideModal(null);
  }

  onClosed(event: any) {
    if (this.showModal != false) {
      this.showModal = false;
      this.showModalChange.emit(this.showModal);
    }
  }

  //Moment date Functions for fia appliations
  myDateFilter = (m: Moment | null): boolean => {
    const today = m || moment();
    return today >= moment().utcOffset('+02:00').subtract(0, 'days');
  };

  hasAnyPendingApplications(): boolean {
    // status of 1-3 are considered pending and 4 and above are either approved or declined etc (not pending).
    const filteredApps = this.fiaApplications.filter((x) => Number(x.status) < 4);
    if (filteredApps.length > 0) {
      return true;
    }
    return false;
  }

  showHideModal(toggle: boolean) {
    if (toggle != null) {
      this.showModal = toggle;
    }

    if (this.showModal) {
      this.GetUserMedia();
      if (this.fiaApplications && this.fiaApplications.length > 0) {
        this.isPending = this.hasAnyPendingApplications();
        if (this.isPending) {
          this.errorMsg = 'There is already a pending (not yet completed) FIA Application for this user. Try again later';
          this.showError = this.isPending;
        }
      }
      this.userFiaApplicationModal.show();
      this.userProfile = <UserProfile>JSON.parse(JSON.stringify(this.selectedUserProfile));
      this.newFia.userId = this.userProfile.userId;
      this.GetLeftToApplyFor();
    } else {
      // Blur any focused element before hiding modal to prevent aria-hidden warning
      if (document.activeElement instanceof HTMLElement) {
        document.activeElement.blur();
      }
      this.newFia = new Fia();
      this.supportingApplicationDocumentsError = false;
      this.userNewDocuments = [];
      this.supportingApplicationDocuments = [];
      this.clearErrors();
      this.userFiaApplicationModal.hide();
      this.file = undefined;
    }

    this.showModalChange.emit(this.showModal);
  }

  GetUserMedia() {
    this.busy = true;
    this.mediaService
      .GetFiaSupportingDocuments(this.selectedUserProfile.userId, this.settingsService.fiaSupportingMediaTypes[1].Id)
      .subscribe(
        (response) => {
          this.supportingApplicationDocuments = response;
          this.busy = false;
        },
        (error) => {
          this.showError = true;
          this.errorMsg = error.error.ErrorDetail;
          this.busy = false;
        }
      );
  }

  fiaApplicationApplyClicked() {
    this.busy = true;

    if (this.userNewDocuments.length == 0) {
      this.showError = true;
      this.errorMsg = 'No supporting documents attached';
      this.busy = false;
      return;
    }

    for (var i = 0; i != this.userNewDocuments.length; i++) {
      var x = this.userNewDocuments[i];
      if (!x.fileType || x.fileType == '') {
        this.showError = true;
        this.errorMsg = 'Please select a type for all documents';
        this.busy = false;
        return;
      }
    }

    this.newFia.plannedInvestmentDate = moment().toDate();
    this.fiaService.FiaApplcation(this.newFia).subscribe(
      (response: FiaApplication) => {
        this.UploadFiaSupportingMedia(response).then(() => {
          this.fiaApplications.unshift(response);
          this.showError = false;
          this.busy = false;
          this.onModelChange.emit(this.selectedUserProfile);
          this.showHideModal(false);
        });
      },
      (error) => {
        this.showError = true;
        this.errorMsg = error.error.ErrorDetail;
        this.busy = false;
      }
    );
  }

  public UploadFiaSupportingMedia(fiaApplication: FiaApplication) {
    if (!this.userNewDocuments || this.userNewDocuments.length == 0) {
      return new Promise((resolve) => {
        resolve(true);
      });
    }

    return Promise.all(
      this.userNewDocuments.map(async (v) =>
        this.mediaService.UploadFiaSupportingMediaAsync(this.settingsService.userProfile.userId, fiaApplication.id, v)
      )
    ).then(
      () => {},
      (rejected) => {
        throw rejected;
      }
    );
  }

  addFiles() {
    this.file.nativeElement.click();
  }

  clearErrors() {
    this.showError = false;
    this.errorMsg = '';
  }

  onFileChange(fileInput: any) {
    //this.userNewDocuments = [];
    var totalSize: number = 0;
    var maxSize: number = 5000000;
    const files: { [key: string]: File } = this.file.nativeElement.files;
    for (let key in files) {
      if (!isNaN(parseInt(key))) {
        var reader = new FileReader();
        reader.onload = (event: any) => {
          if (totalSize <= maxSize && files[key].size <= maxSize) {
            this.showError = false;
            var file: MediaInfo = new MediaInfo();
            file.name = files[key].name;
            file.fileName = files[key].name;
            file.mimeType = files[key].type;
            file.fileType = 'Proof Of Source';
            file.tag = 'FiaApplication';
            file.data = event.target.result;
            file.data = file.data.replace('data:' + files[key].type + ';base64,', '');
            file.entityId = this.userProfile.userId;
            file.entityType = this.settingsService.userEntity.description; // Users
            totalSize += files[key].size;
            this.userNewDocuments.push(file);

            // Validate that this is not a PIN document
            this.ValidateIsNotPinDocument(file, file.fileName);
          } else {
            console.log('Max upload size reached');
            this.showError = true;
            this.errorMsg = 'Max file upload size reached';
          }
        };

        reader.readAsDataURL(files[key]);
      }
    }
  }

  removeFile(fileName: string) {
    this.busy = true;
    this.userNewDocuments.forEach((value, index) => {
      if (value.fileName == fileName) {
        this.userNewDocuments.splice(index, 1);
      }
    });
    this.busy = false;
  }

  ValidateIsNotPinDocument(media: MediaInfo, fileName: string) {
    this.showError = false;
    this.errorMsg = '';
    this.fiaService.ValidateFiaPinDocument(media).subscribe(
      (response: UserFiaPinDocument) => {
        if (response.fileClassification == 'Sars Communication - FIA TCS Pin Issued') {
          // This is a PIN document - remove it from the array
          this.userNewDocuments = this.userNewDocuments.filter((doc) => doc.fileName !== fileName);
          this.showError = true;
          this.errorMsg = `PIN document detected: "${fileName}" cannot be uploaded here. Please use the PIN upload feature instead.`;
        }
        // If it's not a PIN document, silently succeed - we only care about rejecting PINs
      },
      (error) => {
        // silently swollow the error since we can't tell if pin we need to let the user upload it
        this.showError = false;
        this.errorMsg = '';
      }
    );
  }

  GetLeftToApplyFor() {
    return new Promise((resolve) => {
      this.busy = true;
      this.fiaLeftToApplyFor = null;
      this.fiaService.CalculateLeftToApplyFor(this.userProfile.userId).subscribe({
        next: (response: FiaLeftToApplyFor) => {
          this.fiaLeftToApplyFor = response;
          this.newFia.fiaAmount = this.suggestAmountToApplyFor();
          this.busy = false;
          resolve(true);
        },
        error: (error) => {
          this.showError = true;
          this.errorMsg = Error.InterpretErrorMessage(error);
          this.busy = false;
          resolve(true);
        },
      });
    });
  }

  private suggestAmountToApplyFor(): number {
    const { maxTradeAmount, bankBalance } = this.fiaLeftToApplyFor;
    const rawAmount = Math.min(maxTradeAmount, bankBalance);
    const roundTo = 100;
    //round down to the nearest 100 for now - may change in future
    return Math.floor(rawAmount / roundTo) * roundTo;
  }
}
